import { useRouter } from "next/router";

import { Button } from "@chef/components";
import { BRAND_PATHS } from "@chef/constants";
import { createReactivationSchedulers, isAccountPaused } from "@chef/helpers";
import { openModal, useBillingQuery } from "@chef/state-management";
import { getCurrentWeekDataAndBasketFromCalendar } from "@chef/state-management/helpers";
import { useAppDispatch, useCalendarData } from "@chef/state-management/hooks";

interface AccountReactivationButtonProps {
  children: React.ReactNode;
  week: number;
  year: number;
  full?: boolean;
}

export const AccountReactivationButton = ({
  children,
  week,
  year,
  full,
}: AccountReactivationButtonProps) => {
  const router = useRouter();
  const dispatch = useAppDispatch();

  const { calendar } = useCalendarData({
    week,
    year,
  });

  const currentWeekObject = getCurrentWeekDataAndBasketFromCalendar({
    calendar: calendar || [],
    week,
    year,
  });

  const isBeforeStartDateWeek = currentWeekObject?.isBeforeStartDateWeek;

  const { data: billingQuery } = useBillingQuery();

  const isPausedAccount = isAccountPaused(billingQuery?.billing.status || 10);

  const handleGoToWeekEditor = async (
    e: React.MouseEvent<HTMLButtonElement>,
  ) => {
    if (isBeforeStartDateWeek) {
      e.preventDefault();
      return;
    }

    if (isPausedAccount) {
      dispatch(
        openModal({
          id: "ACCOUNT_REACTIVATION",
          redirectUrl: BRAND_PATHS.WEEK_EDITOR_PAGE({ week, year }),
          schedulerUpdates: createReactivationSchedulers(week, year),
        }),
      );
      return;
    }

    router.push(BRAND_PATHS.WEEK_EDITOR_PAGE({ week, year }));
  };

  return (
    <>
      <Button
        onClick={handleGoToWeekEditor}
        className="my-2 md:mt-0"
        data-intercom-target="to-week-editor"
        id="to-week-editor"
        full={full}
        primary
      >
        {children}
      </Button>
    </>
  );
};
